module.exports = __webpack_public_path__ + "static/media/JoxT6k21.546def01.jpg";